module.exports = __webpack_public_path__ + "img/trash-clock.24f60237.svg";